module.exports = __webpack_public_path__ + "img/cert1.f1aee9ed.jpg";